import api from './api'

export const agentService = {
  // Perfil del agente - usa /api/auth/profile (unificado)
  async getProfile() {
    const response = await api.get('/api/auth/profile')
    return response.data.agent // El endpoint devuelve {success, agent}
  },

  async updateProfile(profileData: any) {
    const response = await api.put('/api/agents/profile', profileData)
    return response.data
  },

  // Propiedades
  async getProperties() {
    const response = await api.get('/api/agents/properties')
    return response.data
  },

  async createProperty(propertyData: any) {
    const response = await api.post('/api/agents/properties', propertyData)
    return response.data
  },

  async updateProperty(propertyId: string, propertyData: any) {
    const response = await api.put(`/api/agents/properties/${propertyId}`, propertyData)
    return response.data
  },

  async deleteProperty(propertyId: string) {
    const response = await api.delete(`/api/agents/properties/${propertyId}`)
    return response.data
  },

  // Upload de archivos
  async uploadAvatar(file: File) {
    const formData = new FormData()
    formData.append('avatar', file)
    const response = await api.post('/api/agents/avatar', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  },


  async uploadLogo(file: File) {
    const formData = new FormData()
    formData.append('logo', file)
    const response = await api.post('/api/agents/logo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
  },


  async uploadPropertyImages(propertyId: string, files: File[]) {
    const formData = new FormData()
    files.forEach(file => {
      formData.append('images', file)
    })
    const response = await api.post(`/api/agents/properties/${propertyId}/images`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  },

  // Analytics
  async getAnalytics() {
    const response = await api.get('/api/agents/analytics')
    return response.data
  },

  // Documentos
  async getDocuments() {
    const response = await api.get('/api/documents')
    return response.data
  },

  async uploadDocument(file: File, title: string) {
    const formData = new FormData()
    formData.append('document', file)
    formData.append('title', title)
    const response = await api.post('/api/documents/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  },

  async deleteDocument(documentId: string) {
    const response = await api.delete(`/api/documents/${documentId}`)
    return response.data
  },

  // Público (por subdomain)
  async getBySubdomain(subdomain: string) {
    const response = await api.get(`/api/agents/subdomain/${subdomain}`)
    return response.data
  }
}
